import ItLang from './locales/it_IT.json';
import EnLang from './locales/en_EN.json';
import itIT from 'antd/lib/locale/it_IT';
import enUS from 'antd/lib/locale/en_US';

const AppLocale = {
	it: ItLang,
	en: EnLang
};

export const AntdLocale = {
	it: itIT,
	en: enUS
};

export default AppLocale;
